// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import useGetSetting from "@insite/client-framework/Common/Hooks/useGetSetting";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { loadPagesForParent } from "@insite/client-framework/Store/Data/Pages/PagesActionCreators";
import { getPageStateByType } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Hidden from "@insite/mobius/Hidden";
import { IconMemo, IconPresentationProps } from "@insite/mobius/Icon";
import FillCircle from "@insite/mobius/Icons/FillCircle";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ListItem, { ListItemProps, UnorderedList, UnorderedListProps } from "@insite/mobius/Lists";
import Modal from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import CloseCircleFill from "@store/Library/Components/Toolkit/Icons/CloseCircle/CloseCircleFill";
import InfoFill from "@store/Library/Components/Toolkit/Icons/Info/InfoFill";
import constants from "@store/constants";
import {
    addViewedNotesNotification,
    getViewedNotesNotification,
    getViewNotesNotifications,
    toggleViewNotesNotifications,
    ViewedNotesNotificationItem,
    viewNotesClickHandler,
} from "@store/Framework/Services/FeaturesNotificationService";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import parse from "html-react-parser";
import sortBy from "lodash/sortBy";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    numberOfReleasesToShow = "numberOfReleasesToShow",
    showWidgetTitle = "showWidgetTitle",
    animateTitle = "animateTitle",
    animationDelay = "animationDelay",
    animationDuration = "animationDuration",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.numberOfReleasesToShow]: number;
        [fields.showWidgetTitle]: boolean;
        [fields.animateTitle]: boolean;
        [fields.animationDelay]: number;
        [fields.animationDuration]: number;
    };
}

interface NewFeaturesNotificationStyles {
    containerWrapper?: InjectableCss;
    collapsedWidget?: InjectableCss;
    titleWrapper?: FlexWrapperPresentationProps;
    title?: TypographyPresentationProps;
    infoIcon?: IconPresentationProps;
    infoIconCollapsed?: IconPresentationProps;
    closeIconCollapsed?: IconPresentationProps;
    collapseIcon?: IconPresentationProps;
    closeIcon?: IconPresentationProps;
    listWrapper?: InjectableCss;
    releaseList?: UnorderedListProps;
    listItem?: ListItemProps;
    links?: LinkPresentationProps;
    viewAllLink?: LinkPresentationProps;
    actionsWrapper?: InjectableCss;
    releaseNotesSummaryText?: TypographyPresentationProps;
    unreadNotes?: IconPresentationProps;
    unreadNotification?: IconPresentationProps;
    dontShowLink?: LinkPresentationProps;
    releaseItemTitleWrapper?: InjectableCss;
    typeTag?: TypographyProps;
    titleWrapperMobile?: FlexWrapperPresentationProps;
    dontShowLinkMobile?: LinkPresentationProps;
    listWrapperMobile?: InjectableCss;
    newFeaturesTag?: InjectableCss;
}

const sharedContainerStyles: InjectableCss = {
    css: css`
        position: fixed;
        display: flex;
        flex-direction: column;
        filter: drop-shadow(${x => x.theme.shadows.e80});
    `,
};

const newFeaturesNotificationStyles: NewFeaturesNotificationStyles = {
    containerWrapper: {
        css: css`
            ${sharedContainerStyles.css}
            background: ${getColor("primary")};
            color: ${getColor("primary.contrast")};
            width: ${pxToRem(450)};
            bottom: calc(2% + ${pxToRem(60)});
            right: calc(1% + ${pxToRem(60)});
            min-width: ${pxToRem(400)};
            max-height: 70%;
            border-radius: ${pxToRem(10)};
            padding: ${pxToRem(5)};
            z-index: ${x => x.theme.zIndex.toaster};
        `,
    },
    collapsedWidget: {
        css: css`
            ${sharedContainerStyles.css}
            background: ${getColor("tertiary.alt")};
            color: ${getColor("tertiary.contrast")};
            bottom: 2%;
            right: 1%;
            border-radius: ${pxToRem(50)};
            height: ${pxToRem(65)};
            min-width: ${pxToRem(65)};
            cursor: pointer;
        `,
    },
    titleWrapper: {
        extendedStyles: {
            content: {
                css: css`
                    align-items: center;
                    gap: ${pxToRem(8)};
                    padding: ${pxToRem(8, 5, 16, 5)};
                `,
            },
            item: {
                css: css`
                    &:last-child {
                        flex: 1;
                    }
                `,
            },
        },
    },
    infoIcon: {
        src: InfoFill,
        size: 24,
        color: "secondary",
    },
    infoIconCollapsed: {
        src: InfoFill,
        size: 40,
        color: "primary.contrast",
        css: css`
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
        `,
    },
    closeIconCollapsed: {
        src: CloseCircleFill,
        size: 40,
        color: "primary.contrast",
        css: css`
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
        `,
    },
    collapseIcon: {
        src: ChevronDown,
        size: 24,
        color: "primary.contrast",
    },
    title: {
        variant: "h4",
    },
    listWrapper: {
        css: css`
            position: relative;
            background: ${getColor("common.background")};
            color: ${getColor("text")};
            border-radius: ${pxToRem(10)};
            padding: ${pxToRem(16)};
            height: 100%;
            overflow-y: auto;
        `,
    },
    releaseList: {
        css: css`
            height: 100%;
            list-style: none;
            padding-left: 0;
        `,
    },
    listItem: {
        css: css`
            ${spacingStyles()}
            border-bottom: 1px solid ${getColor("common.border")};
            padding-top: ${pxToRem(8)};
            padding-bottom: ${pxToRem(8)};

            &:first-child {
                padding-top: 0;
            }

            &:last-child {
                border-bottom: 0;
                padding-bottom: 0;
            }
        `,
    },
    viewAllLink: {
        css: css`
            ${x => x.theme.link.defaultProps?.css}
            ${linkStyles("primary.contrast", "primary.contrast", false, true)}
            font-size: ${x => x.theme.design.typography.size.smaller};
            margin: ${pxToRem(8, 0, 5, 5)};
        `,
    },
    actionsWrapper: {
        css: css`
            width: 100%;
            text-align: right;
        `,
    },
    releaseNotesSummaryText: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    unreadNotes: {
        src: FillCircle,
        size: 14,
        color: "secondary",
    },
    unreadNotification: {
        src: FillCircle,
        size: 14,
        color: "secondary",
        css: css`
            position: absolute;
            top: 0;
            left: 0;
        `,
    },
    dontShowLink: {
        css: css`
            color: ${getColor("primary.contrast")};
            font-size: ${x => x.theme.design.typography.size.smaller};
            margin: ${pxToRem(8, 0, 5, 0)};
        `,
    },
    releaseItemTitleWrapper: {
        css: css`
            display: flex;
            align-items: center;
            gap: ${pxToRem(8)};
            padding-bottom: ${pxToRem(8)};
        `,
    },
    typeTag: {
        css: css`
            display: inline-block;
            border-radius: ${pxToRem(50)};
            padding: ${pxToRem(3, 16)};
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    titleWrapperMobile: {
        extendedStyles: {
            content: {
                css: css`
                    align-items: center;
                    gap: ${pxToRem(8)};
                    padding-bottom: ${pxToRem(16)};
                `,
            },
            item: {
                css: css`
                    &:last-child {
                        flex: 1;
                    }
                `,
            },
        },
    },
    dontShowLinkMobile: {
        css: css`
            ${linkStyles("text.link", "text.link", false, true)}
            font-size: ${x => x.theme.design.typography.size.smaller};
            margin: ${pxToRem(8, 0, 5, 0)};
        `,
    },
    listWrapperMobile: {
        css: css`
            background: ${getColor("common.background")};
            color: ${getColor("text")};
            border-radius: ${pxToRem(10)};
            overflow-y: hidden;
        `,
    },
    newFeaturesTag: {
        css: css`
            padding: ${pxToRem(10, 85, 10, 25)};
            display: flex;
            align-items: center;
            height: 100%;
            text-transform: uppercase;
            font-weight: ${x => x.theme.design.typography.weight.bold};
            text-align: center;
            filter: drop-shadow(${x => x.theme.shadows.e80});
        `,
    },
};

const mapStateToProps = (state: ApplicationState) => {
    const featureNotesListPage = getPageLinkByPageType(state, constants.pageType.featureNotesList);
    const featureNotesListPageState = getPageStateByType(state, constants.pageType.featureNotesList);
    const pagesDataView = getDataView(state.data.pages, {
        parentNodeId: featureNotesListPage?.id,
    });
    let links: SafeDictionary<PageLinkModel> = {};

    if (pagesDataView.value) {
        links = pagesDataView.value.reduce(
            (links, page) => ({ ...links, [page.nodeId]: getPageLinkByNodeId(state, page.nodeId) }),
            {},
        );
    }

    return {
        pages: {
            ...pagesDataView,
            value: pagesDataView.value?.filter(x => x.fields["excludeFromNavigation"] === false),
        },
        links,
        featureNotesListPage,
        featureNotesListPageState,
        parameter: featureNotesListPage
            ? state.greif.pages.featureNotesList.getFeatureNotesPagesParameters[featureNotesListPage.id] ?? {
                  parentNodeId: featureNotesListPage?.id,
              }
            : undefined,
        cookieDrawerIsOpen: state.greif.components.cookiePrivacyPolicy.isOpen,
    };
};

const mapDispatchToProps = {
    loadPagesForParent,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const styles = newFeaturesNotificationStyles;

const NewFeaturesNotification = ({
    links,
    pages,
    parameter,
    loadPagesForParent,
    featureNotesListPage,
    cookieDrawerIsOpen,
    fields: { numberOfReleasesToShow, showWidgetTitle, animateTitle, animationDelay, animationDuration },
    history,
}: Props) => {
    const [newestReleases, setNewestReleases] = useState<PageProps[]>([]);
    const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [viewNotifications, setViewNotifications] = useState<boolean>(true);
    const [viewedNotes, setViewedNotes] = useState<ViewedNotesNotificationItem[]>();

    const viewedNotesNotification = getViewedNotesNotification();

    useEffect(() => {
        if (parameter && !pages.isLoading && !pages.value) {
            loadPagesForParent(parameter);
        }

        if (!pages.isLoading && pages.value) {
            const sortedReleases = sortBy(pages.value, o => o.fields["publishDate"])
                .filter(x => (x.fields["unpublishDate"] ? new Date(x.fields["unpublishDate"]) > new Date() : true))
                .reverse()
                .slice(0, numberOfReleasesToShow);
            setNewestReleases(sortedReleases);
        }
    }, [pages]);

    useEffect(() => {
        const viewNotificationsStorage = Boolean(getViewNotesNotifications());

        if (!viewNotificationsStorage) {
            setViewNotifications(false);
        }

        setViewNotifications(viewNotificationsStorage);
    }, [viewNotifications]);

    useEffect(() => {
        setViewedNotes(viewedNotesNotification);
    }, []);

    const viewAllNotesClickHandler = () => {
        if (featureNotesListPage) {
            history.push(featureNotesListPage.url);
        }
    };

    const handleOpenNotificationDisplay = () => {
        setIsCollapsed(false);
    };

    const handleCloseNotificationDisplay = () => {
        setIsCollapsed(true);
    };

    const handleOpenNotificationDisplayMobile = () => {
        setIsModalOpen(true);
    };

    const handleCloseNotificationDisplayMobile = () => {
        setIsModalOpen(false);
    };

    const handleHideNotifications = () => {
        toggleViewNotesNotifications();
        setViewNotifications(!viewNotifications);
    };

    if (!newestReleases || newestReleases?.length === 0 || !viewNotifications) {
        return null;
    }

    const versionNumberBlockStyles = (page: PageProps) => {
        switch (page.fields["releaseType"]) {
            case "Minor":
                return {
                    css: css`
                        ${styles.typeTag?.css}
                        background-color: ${getColor("primary.alt")};
                        color: ${getColor("primary.contrast")};
                    `,
                };
            case "Major":
                return {
                    css: css`
                        ${styles.typeTag?.css}
                        background-color: ${getColor("secondary.alt")};
                        color: ${getColor("neutral.contrast")};
                    `,
                };
            case "Hotfix":
                return {
                    css: css`
                        ${styles.typeTag?.css}
                        background-color: ${getColor("tertiary.alt")};
                        color: ${getColor("tertiary.contrast")};
                    `,
                };
        }
    };

    const newFeatureTitleCollapsedWidgetStyles = {
        css: css`
            @keyframes slideOut {
                from {
                    opacity: 1;
                    overflow-x: auto;
                }
                to {
                    opacity: 0;
                    overflow-x: hidden;
                    display: none;
                }
            }

            ${styles.collapsedWidget?.css}
            ${cookieDrawerIsOpen ? `bottom: calc(2% + ${pxToRem(100)});` : null}
            ${animateTitle
                ? `animation: slideOut ${animationDuration}ms linear ${animationDelay}ms 1 forwards`
                : undefined};
        `,
    };

    const collapsedWidgetStyles = {
        css: css`
            ${styles.collapsedWidget?.css}
            ${cookieDrawerIsOpen ? `bottom: calc(2% + ${pxToRem(100)});` : null}
        `,
    };

    const newFeaturesTitle = translate("New features");
    const newFeaturesId = "view_new_features";

    const unreadNotification = !newestReleases.every(x => viewedNotesNotification.find(y => y.notesId === x.id));

    // for some unknown reason creating a useless function to translate the text allows the linter to see the disable comment...
    const translatingDynamicData = (data: string) => {
        // eslint-disable-next-line spire/avoid-dynamic-translate
        return translate(data);
    };

    const ReleaseList = (isMobile = false) => {
        return (
            <>
                <FlexWrapper {...(isMobile ? styles.titleWrapperMobile : styles.titleWrapper)}>
                    <IconMemo {...styles.infoIcon} />
                    <Typography {...styles.title}>{newFeaturesTitle}</Typography>
                    <StyledWrapper {...styles.actionsWrapper}>
                        <Link
                            {...(isMobile ? styles.dontShowLinkMobile : styles.dontShowLink)}
                            onClick={handleHideNotifications}
                        >
                            {translate("Don't show again")}
                        </Link>
                    </StyledWrapper>
                </FlexWrapper>
                <StyledWrapper {...(isMobile ? styles.listWrapperMobile : styles.listWrapper)}>
                    <UnorderedList {...styles.releaseList}>
                        {newestReleases.length === 0 ? (
                            <Typography>{translate("No new releases found.")}</Typography>
                        ) : (
                            newestReleases.map(releaseItem => (
                                <ListItem {...styles.listItem} key={releaseItem.id}>
                                    <StyledWrapper {...styles.releaseItemTitleWrapper}>
                                        {viewedNotes && !viewedNotes.find(x => x.notesId === releaseItem.id) && (
                                            <IconMemo {...styles.unreadNotes} />
                                        )}
                                        <Link
                                            onClick={() =>
                                                viewNotesClickHandler(
                                                    history,
                                                    links[releaseItem.nodeId],
                                                    releaseItem.id,
                                                )
                                            }
                                            {...styles.links}
                                        >
                                            {releaseItem.fields["title"]}
                                        </Link>
                                        <Typography {...versionNumberBlockStyles(releaseItem)}>
                                            {translatingDynamicData(releaseItem.fields["releaseType"])}
                                        </Typography>
                                        <Typography as="span">
                                            <LocalizedDateTime dateTime={new Date(releaseItem.fields["publishDate"])} />
                                        </Typography>
                                    </StyledWrapper>
                                    {releaseItem.fields["notesSummary"] && (
                                        <Typography {...styles.releaseNotesSummaryText}>
                                            {parse(releaseItem.fields["notesSummary"], parserOptions)}
                                        </Typography>
                                    )}
                                </ListItem>
                            ))
                        )}
                    </UnorderedList>
                </StyledWrapper>
                <Link onClick={viewAllNotesClickHandler} {...styles.viewAllLink}>
                    {translate("View all notes")}
                </Link>
            </>
        );
    };

    return (
        <>
            <Hidden below="md">
                {isCollapsed && showWidgetTitle && unreadNotification && (
                    <StyledWrapper
                        {...newFeatureTitleCollapsedWidgetStyles}
                        title={`View the ${newFeaturesTitle.toLocaleLowerCase()}`}
                        id={newFeaturesId}
                    >
                        <StyledWrapper {...styles.newFeaturesTag}>
                            <Typography>{newFeaturesTitle}</Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                )}
                {isCollapsed ? (
                    <StyledWrapper
                        {...collapsedWidgetStyles}
                        onClick={handleOpenNotificationDisplay}
                        title={`View the ${newFeaturesTitle.toLocaleLowerCase()}`}
                        id={newFeaturesId}
                    >
                        {unreadNotification && <IconMemo {...styles.unreadNotification} size={20} />}
                        <IconMemo {...styles.infoIconCollapsed} />
                    </StyledWrapper>
                ) : (
                    <StyledWrapper
                        {...collapsedWidgetStyles}
                        onClick={handleCloseNotificationDisplay}
                        title={`View the ${newFeaturesTitle.toLocaleLowerCase()}`}
                        id={newFeaturesId}
                    >
                        <IconMemo {...styles.closeIconCollapsed} />
                    </StyledWrapper>
                )}
                {!isCollapsed && <StyledWrapper {...styles.containerWrapper}>{ReleaseList()}</StyledWrapper>}
            </Hidden>
            <Hidden above="sm">
                <StyledWrapper
                    {...collapsedWidgetStyles}
                    onClick={handleOpenNotificationDisplayMobile}
                    title={`View the ${newFeaturesTitle.toLocaleLowerCase()}`}
                    id={newFeaturesId}
                >
                    {unreadNotification && <IconMemo {...styles.unreadNotification} size={20} />}
                    <IconMemo {...styles.infoIconCollapsed} />
                </StyledWrapper>
                <Modal isOpen={isModalOpen} handleClose={handleCloseNotificationDisplayMobile}>
                    {ReleaseList(true)}
                </Modal>
            </Hidden>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(NewFeaturesNotification)),
    definition: {
        displayName: "New Features Notification",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.numberOfReleasesToShow,
                displayName: "Number of Releases to show",
                editorTemplate: "IntegerField",
                min: 1,
                max: 5,
                defaultValue: 3,
                fieldType: "General",
            },
            {
                name: fields.showWidgetTitle,
                displayName: "Show Notification Display Title",
                editorTemplate: "CheckboxField",
                variant: "toggle",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.animateTitle,
                displayName: "Animate widget title?",
                editorTemplate: "CheckboxField",
                variant: "toggle",
                defaultValue: true,
                fieldType: "General",
                isVisible: x => x.fields.showWidgetTitle,
            },
            {
                name: fields.animationDelay,
                displayName: "Animation Delay (in milliseconds)",
                editorTemplate: "IntegerField",
                min: 100,
                max: 5000,
                defaultValue: 2000,
                fieldType: "General",
                isVisible: x => x.fields.showWidgetTitle,
            },
            {
                name: fields.animationDuration,
                displayName: "Animation Duration (in milliseconds)",
                editorTemplate: "IntegerField",
                min: 100,
                max: 2000,
                defaultValue: 200,
                fieldType: "General",
                isVisible: x => x.fields.showWidgetTitle,
            },
        ],
    },
};

export default widgetModule;
